// extracted by css-extract-rspack-plugin
export default {"link":"donateButton-module__link___XmVAt","donateButton":"donateButton-module__donateButton___i5j7D"};